module.exports = __webpack_public_path__ + "static/media/freezvix-3.09c13073.jpg";